export function onSuccess(message) {
  message = message.toString();

  alert(message);
}
